module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Band-Of-Brothers-S1.476ddbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Band-Of-Brothers-S1.jpg
// module id = Jr1H
// module chunks = 0